import { SparklesIcon } from '@heroicons/react/24/solid';
import { Switch } from '@main/complykit';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { DrawerProperty } from '@main/ui';

import { useUpdateOrganizationHandler } from './use-update-org-handler';

export const VendorQuestionnaireAIReviewSwitch = ({ orgId }: { orgId: string }) => {
  const { data } = useGetOrganizationQuery({ orgId });
  const organization = data?.organizations_by_pk;
  const [updateOrganization, { isLoading }] = useUpdateOrganizationMutation();
  const updateOrgHanlder = useUpdateOrganizationHandler(orgId);

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label
        icon={SparklesIcon}
        id="vendor-questionnaire-ai-review-label"
        htmlFor="vendor-questionnaire-ai-review"
      >
        Vendor questionnaire AI review
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} display="flex" alignItems="center">
        <Switch
          id="vendor-questionnaire-ai-review"
          aria-labelledby="vendor-questionnaire-ai-review-label"
          isSelected={organization.is_vendor_questionnaire_ai_review_enabled}
          isPending={isLoading}
          isDisabled={!organization.is_vendors_module_enabled}
          onChange={async () => {
            updateOrgHanlder(
              updateOrganization({
                organization_id: orgId,
                updatePayload: {
                  is_vendor_questionnaire_ai_review_enabled:
                    !organization.is_vendor_questionnaire_ai_review_enabled,
                },
              }),
            );
          }}
        />
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
